import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type StaticListFilter,
} from '../types/filters';
import { prestigeDefinition, prestigeHandler } from './prestige';

export const multiPrestigeDefinition: FilterDefinition<
  MultiFilter<StaticListFilter>
> = {
  id: FilterId.MULTI_PRESTIGE,
  name: 'Prestige',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.PRESTIGE,
  instances: [],
  isVisible: true,
};

export const multiPrestigeHandler: FilterHandler<
  MultiFilter<StaticListFilter>
> = {
  isActive(currentFilterState: MultiFilter<StaticListFilter>) {
    return currentFilterState.instances.some((instance) =>
      prestigeHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<StaticListFilter>,
    _definition: FilterDefinition<MultiFilter<StaticListFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<StaticListFilter>,
    _definition: FilterDefinition<MultiFilter<StaticListFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      prestigeHandler.getEffectiveFilter(instance, prestigeDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
